<template>
<div class="color" :style="style" v-on:click="click();" :title="name" v-bind:class="{'selected':(is_selected)}">
</div>
</template>

<script>
export default {
	name: 'Color',
	props: ['info'],
	computed: {
		style() {
			return "background-color: " + this.info.color + ";";
		},
		name() {
			return this.info.name;
		},
		is_selected() {
			return this.info.selected;
		}
	},
	methods: {
		click() {
			this.$store.dispatch('toggle_color', this.info.ident);
		},
	},
}
</script>

<style scoped>

div.color {
	width: 2em;
	min-width: 2em;
	max-width: 2em;
	height: 2em;
	min-height: 2em;
	max-height: 2em;
	display: table;
	margin: 0.3em 0.3em 0.3em 0.3em;
	border-radius: 0.5em;
	transition:all 0.3s ease;
	opacity: 0.25;
}

div.selected {
	opacity: 1.0;
}

div.color:hover {
	transform: scale(1.15);
}

</style>



// WEBPACK FOOTER //
// src/components/Color.vue